import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  TooltipTrigger,
  Tooltip,
  Type,
  ButtonIcon,
  IconHelpAlt,
} from '@spotify-internal/encore-creator-web';
import styles from './index.module.scss';
import { injectIntl, FormattedNumber, defineMessages } from 'react-intl';

export class MetricsWidget extends PureComponent {
  static propTypes = {
    metadata: PropTypes.shape({
      starts: PropTypes.number,
      streams: PropTypes.number,
      listeners: PropTypes.number,
      followers: PropTypes.number,
    }).isRequired,
    metricsKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  state = {
    showTooltip: {
      starts: false,
      streams: false,
      listeners: false,
      followers: false,
    },
  };

  metricTooltipMessages = defineMessages({
    starts: {
      id: 'metrics-widget.tooltip-starts',
      defaultMessage:
        'Measured when a Spotify user listens to 0 seconds or more of any episode in your catalog.',
    },
    streams: {
      id: 'metrics-widget.tooltip-streams',
      defaultMessage:
        'Measured when a Spotify user listens to 60 seconds or more of any episode in your catalog.',
    },
    listeners: {
      id: 'metrics-widget.tooltip-listeners',
      defaultMessage:
        'Measures the number of unique Spotify users who started an episode in your catalog.',
    },
    followers: {
      id: 'metrics-widget.tooltip-followers',
      defaultMessage:
        'Measures the number of Spotify users who clicked follow on a podcast in your catalog.',
    },
  });

  metricTitlesMessages = defineMessages({
    starts: {
      id: 'metrics-widget.titles-starts',
      defaultMessage: 'starts',
    },
    streams: {
      id: 'metrics-widget.titles-streams',
      defaultMessage: 'streams',
    },
    listeners: {
      id: 'metrics-widget.titles-listeners',
      defaultMessage: 'listeners',
    },
    followers: {
      id: 'metrics-widget.titles-followers',
      defaultMessage: 'followers',
    },
  });

  buildMetricComponent = (key, value) => (
    <div
      data-qa={`${key}-performance-metric`}
      key={`${key}-performance-metric`}
      className={styles.metric}
    >
      <Type as="h1" variant={Type.heading2} condensed>
        <FormattedNumber value={value} />
      </Type>
      <Type
        as="span"
        variant={Type.body1}
        color="gray60"
        condensed
        className={styles['with-tooltip']}
      >
        {this.props.intl.formatMessage(this.metricTitlesMessages[key])}
        <TooltipTrigger
          overlay={
            /* istanbul ignore next */ this.state.showTooltip[key] && (
              <Tooltip>{this.props.intl.formatMessage(this.metricTooltipMessages[key])}</Tooltip>
            )
          }
          placement="bottom"
          onShow={/* istanbul ignore next */ () => this.setState({ showTooltip: { [key]: true } })}
          onHide={/* istanbul ignore next */ () => this.setState({ showTooltip: { [key]: false } })}
        >
          <ButtonIcon style={{ marginLeft: '5px' }}>
            <IconHelpAlt iconSize={16} />
          </ButtonIcon>
        </TooltipTrigger>
      </Type>
    </div>
  );

  render() {
    const { metadata, metricsKeys } = this.props;

    return (
      <div data-qa="performance-metrics-widget" className={styles['metrics-container']}>
        {metricsKeys.map(key => this.buildMetricComponent(key, metadata[key]))}
      </div>
    );
  }
}

export const MetricsWidgetWithRouter = withRouter(injectIntl(MetricsWidget));
